export function extractPrice(
  price?: number | null,
  part?: 'main' | 'decimal',
): string | undefined {
  if (!price) return;

  const [main, decimal] = price.toFixed(2).toString().split('.');

  if (part === 'main') return main;

  if (part === 'decimal') return decimal === '00' ? undefined : `.${decimal}`;

  return decimal === '00' ? main : `${main}.${decimal}`;
}
